// Debug utilities for TP module

// Enable debug logs only in development environment
const DEBUG_ENABLED = process.env.NODE_ENV === 'development';

// Debug log levels
const LOG_LEVELS = {
  ERROR: 0,
  WARN: 1, 
  INFO: 2,
  DEBUG: 3
};

// Current log level - reduced to INFO in development to minimize noise
const CURRENT_LOG_LEVEL = DEBUG_ENABLED ? LOG_LEVELS.INFO : LOG_LEVELS.ERROR;

// Main debug logger
export const debugLog = (component, message, data = null, level = 'debug') => {
  if (!DEBUG_ENABLED) return;
  
  const logLevel = LOG_LEVELS[level.toUpperCase()] || LOG_LEVELS.DEBUG;
  if (logLevel > CURRENT_LOG_LEVEL) return;
  
  const timestamp = new Date().toISOString().slice(11, 23); // HH:mm:ss.sss
  const prefix = `[${timestamp}] [${component}]`;
  
  switch (level.toLowerCase()) {
    case 'error':
      console.error(`${prefix} ${message}`, data || '');
      break;
    case 'warn':
      console.warn(`${prefix} ${message}`, data || '');
      break;
    case 'info':
      console.info(`${prefix} ${message}`, data || '');
      break;
    case 'debug':
    default:
      console.log(`${prefix} ${message}`, data || '');
      break;
  }
};

// Quick performance timer
export const debugTime = (component, operation) => {
  if (!DEBUG_ENABLED) return () => {};
  
  const startTime = performance.now();
  
  return () => {
    const duration = performance.now() - startTime;
    debugLog(component, `${operation} completed in ${duration.toFixed(2)}ms`, null, 'info');
  };
};

// Shortcuts for different components (using appropriate log levels)
export const mapDebug = (msg, data, level = 'debug') => debugLog('MAP', msg, data, level);
export const pathDebug = (msg, data, level = 'debug') => debugLog('PATH', msg, data, level);
export const contextDebug = (msg, data, level = 'debug') => debugLog('CTX', msg, data, level);
export const tpDebug = (msg, data, level = 'debug') => debugLog('TP', msg, data, level);

export const isDebugEnabled = () => DEBUG_ENABLED;
